import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider--left",
  "use": "icon-slider--left-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-slider--left\"><path d=\"m14.828 8.464-10.11-.005L9.31 3.865l-.77-.77L2.636 9l5.905 5.905.77-.77L4.717 9.54l10.11-.005V8.464Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol